import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuItemDirective, MenuItemsDirective } from './items.directive';
import { MenuComponent } from './menu.component';
/**
 * NgModule definition for the Menu component.
 */
export class MenuModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        MenuComponent,
        MenuItemDirective,
        MenuItemsDirective
    ],
    exports: [
        MenuComponent,
        MenuItemDirective,
        MenuItemsDirective
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MenuModule_tsickle_Closure_declarations() {
/** @type {?} */
MenuModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MenuModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
